// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { CaseOutput, SeverityValues } from 'thehive-sdk';
import CaseNumber from '@Organisms/Case/CaseNumber/CaseNumber';
import { classList } from '@Helpers/className';

import './CaseTitle.scss';

interface CaseTitleProps {
    caseNumber: number;
    title: string;
    severity: SeverityValues;
    onTitleClick?: () => void;
    onCaseNumberClick?: (severity: SeverityValues, caseNumber: number) => void;
    readOnly?: boolean;
    editTitle?: (editTitle: string) => Promise<void | CaseOutput>;
    isFilled?: boolean;
}

const CaseTitle = ({ caseNumber, title, severity = 1, onCaseNumberClick, isFilled }: CaseTitleProps): ReactElement => {
    return (
        <div className="case-title">
            <CaseNumber
                caseNumber={caseNumber}
                className={classList({ 'cursor-pointer': !!onCaseNumberClick })}
                severity={severity}
                hashtag
                fillType={isFilled ? 'fill' : 'outline'}
                onClick={(): void => {
                    onCaseNumberClick?.(severity, caseNumber);
                }}
            />

            <span className="case-title__title">{title}</span>
        </div>
    );
};

export default CaseTitle;
